module.exports = __webpack_public_path__ + "img/staff-seth-clancy.d471526e.jpg";